import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useStudents } from "../context/students";
import useStatuses from "../context/status/useStatuses";
import { STUDENT_STATUS } from "../constants/student.status";

const PREV_STATUS_KEY = "prevStudentStatus";

export const StudentRedirectHandler = ({ children }) => {
    const { activeStudentId } = useStudents();
    const { studentStatus } = useStatuses();
    const navigate = useNavigate();

    const previousStatusRef = useRef(
        localStorage.getItem(PREV_STATUS_KEY) ?? studentStatus,
    );

    useEffect(() => {
        const previousStatus = localStorage.getItem(PREV_STATUS_KEY) ?? previousStatusRef.current;

        if (studentStatus && previousStatus && previousStatus !== studentStatus) {
            const redirectPath = studentStatus === STUDENT_STATUS.STUDENT
                ? `/home/${activeStudentId || ""}`
                : `/dashboard/${activeStudentId || ""}`;

            navigate(redirectPath, { replace: true });
        }

        if (studentStatus) {
            previousStatusRef.current = studentStatus;
            localStorage.setItem(PREV_STATUS_KEY, studentStatus);
        }
    }, [studentStatus, activeStudentId, navigate]);

    return children;
};
